import React from 'react';

import axios from 'axios';
import PropTypes from 'prop-types';

import { useTrackDownload } from '@src/hooks/useTrackDownload';
import { currentJwt } from '@src/utils/jwtHelpers';

const Download = ({
    attachment,
    children = 'Download',
    resourceType = 'Attachment',
    resourceId = null,
    ...linkProps
}) => {
    const { trackDownload } = useTrackDownload();

    const handleSuccess = (downloadAttachment) => {
        if (!downloadAttachment?.download_url) return;
        const a = document.createElement('a');
        a.href = downloadAttachment.download_url;
        a.download = downloadAttachment.filename || 'download';
        a.click();
    };

    const getPreSignedUrl = async (id) => {
        const url = `${process.env.API_HOST_URL}/api/v1/attachments/${id}/download`;
        const token = currentJwt();
        const options = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        return axios.get(url, options);
    };

    const handleClick = (e) => {
        e.preventDefault();

        trackDownload(resourceType, resourceId || attachment.id);

        getPreSignedUrl(attachment.id)
            .then((response) => {
                const attachmentData = response.data?.attachment || response.data;
                handleSuccess(attachmentData);
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error(error);
            });
    };

    return (
        <a
            className="btn btn-outline-primary stretched-link"
            href={`/attachments?name=${attachment.filename}&id=${attachment.id}`}
            onClick={handleClick}
            {...linkProps}
        >
            {children}
        </a>
    );
};

Download.propTypes = {
    attachment: PropTypes.shape({
        id: PropTypes.number.isRequired,
        filename: PropTypes.string.isRequired,
    }).isRequired,
    children: PropTypes.node,
    resourceType: PropTypes.string,
    resourceId: PropTypes.number,
};

export default Download;
